import shivjayanti from "../../assests/images/home/shivjayati.jpg";

function Home() {
  const contents = (
    <div className="Row">
      
      <div style={{display:'flex',width:'50rem',height:'28.125rem',marginBottom:'1rem',
              }} >
                  <img src={shivjayanti} border="0px" style={{ width: '100%', height: '100%', borderRadius: '2.5rem', border: '3px solid #fe6902' }} />

      </div>
    </div>
  );

  return contents;
}

export default Home;
